"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "@/components/image";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { Link } from "@/i18n/routing";
import { BookOpenIcon, BrainCircuitIcon, FolderIcon, LanguagesIcon, MailIcon, MenuIcon, StarIcon, UserIcon } from "lucide-react";
import * as motion from "motion/react-client";
import { useLocale, useTranslations } from "next-intl";
import { useState } from "react";
const anchorItems = [{
  id: "about",
  icon: UserIcon,
  labelKey: "sections.about.title"
}, {
  id: "ai",
  icon: BrainCircuitIcon,
  labelKey: "sections.ai.title"
}, {
  id: "projects",
  icon: FolderIcon,
  labelKey: "sections.projects.title"
}, {
  id: "testimonials",
  icon: StarIcon,
  labelKey: "sections.testimonials.title"
}, {
  id: "contact",
  icon: MailIcon,
  labelKey: "sections.contactForm.title"
}];
const Header = () => {
  const $ = _c(48);
  const locale = useLocale();
  const t = useTranslations("Home");
  const tBlog = useTranslations("blog");
  const [open, setOpen] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      translateY: -20,
      opacity: 0
    };
    t1 = {
      translateY: 0,
      opacity: 1
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      duration: 0.6,
      ease: [0.25, 0.1, 0.25, 1]
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="h-px bg-linear-to-r from-transparent via-[hsl(var(--accent))]/40 to-transparent" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Link href="/"><motion.div whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} transition={{
        type: "spring",
        stiffness: 400,
        damping: 17
      }}><Image src="/images/logo.png" alt="Logo" width={120} height={120} className="size-8 rounded-lg" /></motion.div></Link>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t) {
    t5 = anchorItems.map((item, i) => <motion.a key={item.id} href={`#${item.id}`} initial={{
      opacity: 0,
      translateY: -10
    }} animate={{
      opacity: 1,
      translateY: 0
    }} transition={{
      delay: 0.3 + i * 0.07,
      duration: 0.4,
      ease: "easeOut"
    }} whileHover={{
      scale: 1.05
    }} className="px-3 py-1.5 rounded-md text-xs font-medium text-muted-foreground hover:text-foreground hover:bg-secondary/80 transition-colors">{t(item.labelKey as any)}</motion.a>);
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  let t7;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      opacity: 0,
      translateY: -10
    };
    t7 = {
      opacity: 1,
      translateY: 0
    };
    t8 = {
      delay: 0.3 + anchorItems.length * 0.07,
      duration: 0.4,
      ease: "easeOut"
    };
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
  } else {
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
  }
  let t9;
  if ($[10] !== tBlog) {
    t9 = tBlog("title");
    $[10] = tBlog;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t9) {
    t10 = <motion.div initial={t6} animate={t7} transition={t8}><Link href="/blog" className="px-3 py-1.5 rounded-md text-xs font-medium text-muted-foreground hover:text-foreground hover:bg-secondary/80 transition-colors">{t9}</Link></motion.div>;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t5) {
    t11 = <nav className="hidden md:flex items-center gap-0.5">{t5}{t10}</nav>;
    $[14] = t10;
    $[15] = t5;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const t12 = locale === "en" ? "it" : "en";
  let t13;
  let t14;
  let t15;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      scale: 1.05
    };
    t14 = {
      scale: 0.95
    };
    t15 = {
      type: "spring",
      stiffness: 400,
      damping: 17
    };
    $[17] = t13;
    $[18] = t14;
    $[19] = t15;
  } else {
    t13 = $[17];
    t14 = $[18];
    t15 = $[19];
  }
  let t16;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <LanguagesIcon className="size-4" />;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  const t17 = locale === "en" ? "IT" : "EN";
  let t18;
  if ($[21] !== t17) {
    t18 = <motion.div whileHover={t13} whileTap={t14} transition={t15}><Button type="button" variant="ghost" size="sm" className="text-muted-foreground hover:text-foreground">{t16}{t17}</Button></motion.div>;
    $[21] = t17;
    $[22] = t18;
  } else {
    t18 = $[22];
  }
  let t19;
  if ($[23] !== t12 || $[24] !== t18) {
    t19 = <Link href="/" locale={t12}>{t18}</Link>;
    $[23] = t12;
    $[24] = t18;
    $[25] = t19;
  } else {
    t19 = $[25];
  }
  let t20;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <SheetTrigger asChild={true}><Button type="button" variant="ghost" size="icon" className="md:hidden text-muted-foreground"><MenuIcon className="size-5" /></Button></SheetTrigger>;
    $[26] = t20;
  } else {
    t20 = $[26];
  }
  let t21;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <SheetHeader><SheetTitle>Menu</SheetTitle></SheetHeader>;
    $[27] = t21;
  } else {
    t21 = $[27];
  }
  let t22;
  if ($[28] !== t) {
    t22 = anchorItems.map(item_0 => <a key={item_0.id} href={`#${item_0.id}`} onClick={() => setOpen(false)} className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-muted-foreground hover:text-foreground hover:bg-secondary transition-colors"><item_0.icon className="size-4 shrink-0" /><span>{t(item_0.labelKey as any)}</span></a>);
    $[28] = t;
    $[29] = t22;
  } else {
    t22 = $[29];
  }
  let t23;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = () => setOpen(false);
    $[30] = t23;
  } else {
    t23 = $[30];
  }
  let t24;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <BookOpenIcon className="size-4 shrink-0" />;
    $[31] = t24;
  } else {
    t24 = $[31];
  }
  let t25;
  if ($[32] !== tBlog) {
    t25 = tBlog("title");
    $[32] = tBlog;
    $[33] = t25;
  } else {
    t25 = $[33];
  }
  let t26;
  if ($[34] !== t25) {
    t26 = <Link href="/blog" onClick={t23} className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-muted-foreground hover:text-foreground hover:bg-secondary transition-colors">{t24}<span>{t25}</span></Link>;
    $[34] = t25;
    $[35] = t26;
  } else {
    t26 = $[35];
  }
  let t27;
  if ($[36] !== t22 || $[37] !== t26) {
    t27 = <SheetContent side="right" className="w-64">{t21}<nav className="flex flex-col gap-1 mt-4">{t22}{t26}</nav></SheetContent>;
    $[36] = t22;
    $[37] = t26;
    $[38] = t27;
  } else {
    t27 = $[38];
  }
  let t28;
  if ($[39] !== open || $[40] !== t27) {
    t28 = <Sheet open={open} onOpenChange={setOpen}>{t20}{t27}</Sheet>;
    $[39] = open;
    $[40] = t27;
    $[41] = t28;
  } else {
    t28 = $[41];
  }
  let t29;
  if ($[42] !== t19 || $[43] !== t28) {
    t29 = <div className="flex items-center gap-2">{t19}{t28}</div>;
    $[42] = t19;
    $[43] = t28;
    $[44] = t29;
  } else {
    t29 = $[44];
  }
  let t30;
  if ($[45] !== t11 || $[46] !== t29) {
    t30 = <motion.header initial={t0} animate={t1} transition={t2} className="sticky top-0 z-50 bg-background/70 backdrop-blur-xl backdrop-saturate-150">{t3}<div className="border-b border-border/60"><div className="mx-auto max-w-6xl flex items-center justify-between px-6 h-14">{t4}{t11}{t29}</div></div></motion.header>;
    $[45] = t11;
    $[46] = t29;
    $[47] = t30;
  } else {
    t30 = $[47];
  }
  return t30;
};
export default Header;